/**
 * @param {jQuery} $
 * @param {AppConfig} config
 * @param {AppLibrary} library
 * @param {Popup} popup
 * @constructor
 */
export let Bar = function ($, config, library, popup) {

  // todo: Зафиксировать стейты бара на бекеэнде в Enum
  /**
   * @type {string}
   */
  let template = `
<div class="slp-bar {{positionClass}}">
    {{#text}}
        <span class="slp-bar-text">{{text}}</span>
    {{/text}}
    {{#button}}
        <button class="slp-bar-button">{{button}}</button>
    {{/button}}
</div>`;

  /**
   * @type {*}
   */
  let texts = config.getTexts().bar;

  /**
   * @type {{id: int, balance: int}}
   */
  let customer = config.getCustomer();

  /**
   * @type {{}}
   */
  const POSITION_CLASSES = {
    top_static: 'slp-top-static',
    top_fixed: 'slp-top-fixed',
    bottom_fixed: 'slp-bottom-fixed',
  };

  /**
   * @type {[*]}
   */
  const STATES = [
    {
      texts: texts.not_logged_in,
      check: (customer) => customer.id === 0,
      btnAction: () => {
        document.location.href = '/account/register';
      }
    },
    {
      texts: texts.no_rewards,
      check: (customer) => customer.balance === 0,
      btnAction: () => {
        this.showPopup();
      }
    },
    {
      texts: texts.available,
      check: (customer) => true,
      btnAction: () => {
        this.showPopup();
      }
    }
  ];

  /**
   * @type {{texts: {title: string, button: string}, btnAction: function}}
   */
  let barState = STATES.find((state) => state.check(customer));

  /**
   * @type {HTMLElement}
   */
  let barElement;

  /**
   *
   */
  let init = () => {
    barElement = document.createElement('div');
    barElement.className = 'slp-bar-wrapper';
    barElement.style.display = 'none';
    barElement.innerHTML = library.mustache().render(
      config.customization().barTemplate || template,
      {
        positionClass: POSITION_CLASSES[config.getBarPosition()],
        text: barState.texts.title,
        button: barState.texts.button
      }
    );
    document.body.insertBefore(barElement, document.body.firstElementChild);

    let btn = barElement.querySelector('button');
    if (btn) {
      library.addEventListener(btn, 'click', () => barState.btnAction());
    }
  };

  /**
   *
   */
  this.show = function () {
    $(barElement).slideDown({
      complete: () => config.customization().onBarShown(this)
    });
  };

  /**
   *
   */
  this.hide = function () {
    $(barElement).slideUp();
  };

  /**
   *
   */
  this.showPopup = function () {
    popup.show();
  };

  /**
   * @return {{bar: HTMLElement, button: HTMLElement|null}}
   */
  this.getDomElements = function () {
    return {
      bar: barElement,
      button: barElement.querySelector('button')
    };
  };

  init();
};